import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { InstallPWA } from "@/components/InstallPWA";

export function Layout({ children }) {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
      <InstallPWA />
    </div>
  );
}
